<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="10">
        <table>
          <tr>
            <td class="pa-2"> ID </td>
            <td class="pl-2"> {{ dealer.id }} </td>
          </tr>
          <tr>
            <td class="pa-2"> ชื่อ - นามสกุล </td>
            <td class="pl-2"> {{ dealer.firstName }} {{ dealer.lastName }} </td>
          </tr>
          <tr>
            <td class="pa-2"> ชื่อเล่น </td>
            <td class="pa-2"> {{ dealer.nickName }} </td>
          </tr>
          <tr>
            <td class="pa-2"> อายุ </td>
            <td class="pa-2"> {{ dealer.dob | displayAge() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Email </td>
            <td class="pa-2"> {{ dealer.email | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> เพศ </td>
            <td class="pa-2"> {{ dealer.gender | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> รหัสตัวแทนเดิม </td>
            <td class="pa-2"> {{ dealer.oldDealerId | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> รหัสตัวแทนแม่ทีม </td>
            <td class="pa-2"> {{ dealer.teamParentId | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> สายทีม </td>
            <td class="pa-2"> {{ dealer.classTeam | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> รหัสสายทีม </td>
            <td class="pa-2"> {{ dealer.classTeamId | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> สถานะ </td>
            <td class="pa-2"> {{ dealer.sellerStatus | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> ที่อยู่ที่สามารถติดต่อได้สะดวก </td>
            <td class="pa-2"> {{ dealer.address | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> จังหวัด </td>
            <td class="pa-2"> {{ dealer.province | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> รหัสไปรษณีย์ </td>
            <td class="pa-2"> {{ dealer.postCode | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> เบอร์โทรศัพท์ที่ติดต่อได้สะดวก </td>
            <td class="pa-2"> {{ dealer.tel | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> LINE ID </td>
            <td class="pa-2"> {{ dealer.lineId | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Instagram </td>
            <td class="pa-2"> {{ dealer.instagram | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Facebook </td>
            <td class="pa-2"> {{ dealer.facebook | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Tiktok </td>
            <td class="pa-2"> {{ dealer.tiktok | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Facebook Fanpage </td>
            <td class="pa-2"> {{ dealer.facebookPage | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> พื้นที่ขาย </td>
            <td class="pa-2"> {{ dealer.sellArea | showDataText() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> วันที่ยอมรับข้อตกลง </td>
            <td class="pa-2"> {{ dealer.acceptedDate | localDate() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> วันที่สมัคร </td>
            <td class="pa-2"> {{ dealer.createdAt | localDate() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> วันที่ Update ล่าสุด </td>
            <td class="pa-2"> {{ dealer.updatedAt | localDate() }} </td>
          </tr>
          <tr>
            <td class="pa-2"> Tags </td>
            <td class="pa-2"> 
              <v-chip
                v-for="(tag, i) in dealer.tags"
                :key="`${index}-${i}`"
                class="mr-1"
                :color="getColor(tag)"
                small
                label >
                {{ tag }}
              </v-chip>
            </td>
          </tr>
        </table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" md="2" class="pa-2">
        สำเนาบัตรประชาชน
      </v-col>
      <v-col cols="4">
        <img
          :src="dealer.nationalCardImageUrl"
          width="300"
          style="margin: auto;"
          @error="imgCheck('nationalCard')"
          v-if="hasNationalCartImg">
        <div v-else>
          <a :href="dealer.nationalCardImageUrl" target="_blank">The image</a> could not be loaded.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4" md="2" class="pa-2">
        รูปสำหรับบัตรตัวแทน
      </v-col>
      <v-col cols="4">
        <img
          :src="dealer.sellerCardImageUrl"
          width="300"
          style="margin: auto;"
          @error="imgCheck('seller')"
          v-if="hasSellerImg">
        <div v-else>
          <a :href="dealer.sellerCardImageUrl" target="_blank">The image</a> could not be loaded.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3" offset="2">
        <v-btn block color="warning" :loading="loading" @click="$router.push({ name: 'UpdateDealer', params: { id: dealer.id }})">Update</v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn block color="pink" :loading="loading" @click="confirmRemove">Delete</v-btn>
      </v-col>
      <v-col cols="3" v-if="user.role === 'admin'">
        <v-btn block color="green" :loading="loading" @click="$router.push({ name: 'DealerLogList', params: { id: dealer.id }})">Log</v-btn>
      </v-col>
    </v-row>
    <modal-confirm
      :active="modalConfirm"
      :confirm-text="`Confirm`"
      :title="'Confirm delete'"
      :message="`Confirm delete dealer ${dealer.firstName} ${dealer.lastName}.`"
      :show-cancel="true"
      @onCancel="() => { modalConfirm = false }"
      @onConfirm="removeDealer" />
  </v-container>
</template>

<script>
import DealerProvider from '@/resources/DealerProvider'
import ModalConfirm from '@/components/ModalConfirm'
import { mapActions } from 'vuex'
import { getUser } from '@/utils/js/Auth'
const dealerService = new DealerProvider()
export default {
  components: { ModalConfirm },
  data: () => ({
    loading: false,
    dealer: {},
    user: getUser(),
    modalConfirm: false,
    hasSellerImg: true,
    hasNationalCartImg: true
  }),
  computed: {
    dealerId () {
      return this.$route.params.id ? this.$route.params.id : 0
    }
  },
  async mounted () {
    this.loading = true
    await this.getDealer()
    this.loading = false
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Style/setSnackbar'
    }),
    imgCheck (type) {
      if (type === 'seller') {
        this.hasSellerImg = false
      } else {
        this.hasNationalCartImg = false
      }
    },
    confirmRemove () {
      this.modalConfirm = true
    },
    getColor (tag) {
      const colors = ['pink', 'cyan', 'purple darken-2', 'red',
        'teal', 'teal accent-2', 'lime', 'orange', 'amber',
        'yellow', 'deep-orange', 'light-green accent-4', 'red darken-4', 'purple accent-1', 'blue',
        'indigo', 'teal', 'cyan', 'brown', 'blue-grey', 'brown darken-4', 'amber accent-2', 'yellow accent-4'
      ]
      return colors[tag.length % colors.length]
    },
    async getDealer () {
      try {
        const { data } = await dealerService.getDealerById(this.dealerId)
        this.dealer = data
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      }
    },
    async removeDealer () {
      try {
        this.loading = true
        const { data } = await dealerService.deleteDealer(this.dealerId)
        if (data) {
          this.setSnackbar({
            message: 'Remove dealer success.',
            type: 'success',
            active: true
          })
          this.$router.push({ name: 'DealerList'})
        }
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
